import { Button, styled } from "@mui/material"
import React from "react"

interface FilterDropdownApplyButtonProps {
  onClick: () => void
  amountOfSelectedItems: number
}

const StyledButton = styled(Button)({
  minHeight: 50,
  borderRadius: 0,
})

const FilterDropdownApplyButton = (props: FilterDropdownApplyButtonProps) => {
  const { onClick, amountOfSelectedItems } = props
  return (
    <StyledButton color="primary" variant="contained" onClick={onClick}>
      Apply {`${amountOfSelectedItems} filters`}
    </StyledButton>
  )
}

export default FilterDropdownApplyButton
